module.exports = __webpack_public_path__ + "img/home_img_11.b62d450f.png";